import React from 'react'

import BaseFilter from '../../../components/hooks/BaseFilter'

export default function Filter() {
  return <BaseFilter />
}
